<template>
    <div
        v-show="show"
        class="global-goto-top"
        @click="scrollToTop"
    >
        <span class="iconfont" :class="[icon]"></span>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, defineOptions } from 'vue';
import global from '@/common/global';
defineOptions({
    name: 'GotoTop',
});

defineProps({
    icon: {
        type: String,
        default: 'icon-arrow_05_top',
    },
});

// const { proxy } = getCurrentInstance();
// const isMobileSize = computed(() => {
//     return proxy.platform.isMobile;
// });

const show = ref(false);

const onScroll = (scrollY) => {
    show.value = scrollY > window.innerHeight;
};

const scrollToTop = () => {
    global.scroll(0);
};

onMounted(() => {
    global.scroll(onScroll);
});

onUnmounted(() => {
    global.scroll(onScroll, true);
});
</script>
<style lang="scss">
@import '~@/theme/media.scss';
@import '~@/theme/mixin.scss';

.global-goto-top {
	position: fixed;
	z-index: var(--level-sublow, 10);
	left: 18px;
	bottom: 20px;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	cursor: pointer;
    background-color: var(--g-bg-color);
    box-shadow: 0px 2px 5px 0px rgba(25, 25, 25, 0.3);

	@include media-800 {
		left: auto;
		right: 15px;
		bottom: 85px;
	}
	.iconfont {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: var(--g-primary-color);
		font-weight: bold;
		font-size: 18px;
	}
}
</style>
